export default [
    {
        path: '/admin',
        name: 'admin-home',
        component: () => import('@/views/admin/index.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/benefits',
        name: 'admin-benefit-list',
        component: () => import('@/views/admin/benefits/benefit_list.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/benefits/edit/:id?',
        name: 'admin-benefit-form',
        props: true,
        component: () => import('@/views/admin/benefits/benefit_form.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/chat',
        name: 'admin-chat-channel-list',
        component: () => import('@/views/admin/chat/chat_list.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/chat/edit/:id?',
        name: 'admin-chat-channel-form',
        props: true,
        component: () => import('@/views/admin/chat/chat_form.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/events',
        name: 'admin-event-list',
        component: () => import('@/views/admin/events/event_list.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/events/edit/:id?',
        name: 'admin-event-form',
        props: true,
        component: () => import('@/views/admin/events/event_form.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/events/:id/enrollments',
        name: 'admin-event-enrollments',
        props: true,
        component: () => import('@/views/admin/events/event_enrollments.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/faq',
        name: 'admin-faq-list',
        component: () => import('@/views/admin/faq/faq_list.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/faq/edit/:id?',
        name: 'admin-faq-form',
        props: true,
        component: () => import('@/views/admin/faq/faq_form.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/news',
        name: 'admin-news-list',
        component: () => import('@/views/admin/news/news_list.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/news/edit/:id?',
        name: 'admin-news-form',
        props: true,
        component: () => import('@/views/admin/news/news_form.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/news/:newsId/replies/:pollId',
        name: 'admin-news-poll-replies',
        props: true,
        component: () => import('@/views/admin/news/news_poll_replies.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/pages',
        name: 'admin-page-list',
        component: () => import('@/views/admin/pages/page_list.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/pages/edit/:id?',
        name: 'admin-page-form',
        props: true,
        component: () => import('@/views/admin/pages/page_form.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/pages/stats',
        name: 'admin-pages-stats-overview',
        component: () => import('@/views/admin/pages/stats_overview.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },

    {
        path: '/admin/polls',
        name: 'admin-poll-list',
        component: () => import('@/views/admin/polls/poll_list.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/polls/edit/:id?',
        name: 'admin-poll-form',
        props: true,
        component: () => import('@/views/admin/polls/poll_form.vue'),
        meta: {
            layout: 'admin',
        }
    },
    {
        path: '/admin/polls/replies/:pollId',
        name: 'admin-poll-replies',
        props: true,
        component: () => import('@/views/admin/polls/poll_replies.vue'),
        meta: {
            layout: 'admin',
        }
    },
    {
        path: '/admin/surveys',
        name: 'admin-survey-list',
        component: () => import('@/views/admin/surveys/survey_list.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/surveys/edit/:id?',
        name: 'admin-survey-form',
        props: true,
        component: () => import('@/views/admin/surveys/survey_form.vue'),
        meta: {
            layout: 'admin',
        }
    },
    {
        path: '/admin/surveys/:id/submissions',
        name: 'admin-survey-submissions',
        props: true,
        component: () => import('@/views/admin/surveys/survey_submissions.vue'),
        meta: {
            layout: 'admin',
        }
    },
    {
        path: '/admin/resources',
        name: 'admin-resource-list',
        component: () => import('@/views/admin/resources/resource_list.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/resources/edit/:id?',
        name: 'admin-resource-form',
        props: true,
        component: () => import('@/views/admin/resources/resource_form.vue'),
        meta: {
            layout: 'admin',
        },
    },
    {
        path: '/admin/resources/stats',
        name: 'admin-resources-stats-overview',
        component: () => import('@/views/admin/resources/resource_stats_overview.vue'),
        meta: {
            layout: 'admin',
        },
    },

    {
        path: '/admin/feedback',
        name: 'admin-feedback-list',
        component: () => import('@/views/admin/feedback/feedback_list.vue'),
        meta: {
            layout: 'admin',
            extraPermissions: 'feedbackAdmin'
        },
    },
    {
        path: '/admin/feedback/dashboard',
        name: 'admin-feedback-dashboard',
        component: () => import('@/views/admin/feedback/feedback_dashboard.vue'),
        meta: {
            layout: 'admin',
            extraPermissions: 'feedbackAdmin'
        },
    },
    {
        path: '/admin/feedback/handle/:id',
        name: 'admin-feedback-handle',
        props: true,
        component: () => import('@/views/admin/feedback/feedback_handle.vue'),
        meta: {
            layout: 'admin',
            extraPermissions: 'feedbackAdmin'
        },
    },
    {
        path: '/admin/feedback/:id',
        name: 'admin-feedback-form',
        props: true,
        component: () => import('@/views/admin/feedback/feedback_form.vue'),
        meta: {
            layout: 'admin',
            extraPermissions: 'feedbackAdmin'
        },
    },
    {
        path: '/admin/users',
        name: 'admin-user-list',
        component: () => import('@/views/admin/users/user_list.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/departments',
        name: 'admin-settings-departments',
        component: () => import('@/views/admin/departments/departments.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/groups',
        name: 'admin-groups',
        component: () => import('@/views/admin/groups/groups.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/users/edit/:id?',
        name: 'admin-user-form',
        props: true,
        component: () => import('@/views/admin/users/user_form.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/settings/',
        name: 'admin-settings',
        props: true,
        component: () => import('@/views/admin/settings/settings.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/settings/feedback-categories/edit/:id?',
        name: 'admin-feedback-category-form',
        props: true,
        component: () => import('@/views/admin/settings/feedback_category_edit.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/infotv/screens',
        name: 'admin-infotv-screens',
        props: false,
        component: () => import('@/views/admin/infotv/screens.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/infotv/screens/:screen/settings',
        name: 'admin-infotv-screen-settings',
        props: true,
        component: () => import('@/views/admin/infotv/screen_settings.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/infotv/screens/:screen/content',
        name: 'admin-infotv-screen-content',
        props: true,
        component: () => import('@/views/admin/infotv/screen_content.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/publishing-settings',
        name: 'admin-publishing-settings',
        props: true,
        component: () => import('@/views/admin/publishing-settings/index.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/company-settings',
        name: 'admin-company-settings',
        props: true,
        component: () => import('@/views/admin/company-settings/index.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/settings-hub',
        name: 'admin-settings-hub',
        props: true,
        component: () => import('@/views/admin/settings-hub/index.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/piiri-import/',
        name: 'admin-import',
        props: true,
        component: () => import('@/views/admin/import/import.vue'),
        meta: {
            layout: 'admin',
            tenantAdmin: true
        },
    },
    {
        path: '/admin/changelog/',
        name: 'admin-changelog',
        props: true,
        component: () => import('@/views/admin/changelog/changelog.vue'),
        meta: {
            layout: 'admin'
        },
    },
    {
        path: '/admin/support/',
        name: 'admin-support',
        props: true,
        component: () => import('@/views/admin/support/index.vue'),
        meta: {
            layout: 'admin'
        },
    },
];
